import script from "./CancellationRequestsSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./CancellationRequestsSection.vue?vue&type=script&lang=ts&setup=true"

import "./CancellationRequestsSection.vue?vue&type=style&index=0&id=6e439c00&scoped=true&lang=scss"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e439c00"]])

export default __exports__